import { GroupExpansionStyle, ToggleType } from '@wix/rules-panel-ui';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { verticalsDrillInPageIdAtom } from '../../../../../atoms/session-atoms';
import { usePanelStateAtom } from '../../../../../hooks/rules-state';
import { useNavigation } from '../../../../../hooks/use-navigation';
import { useBasePageGroup } from '../use-base-page-group';
export const useVerticalPageGroup = _ref => {
  let {
    pageId
  } = _ref;
  const {
    getGroupData
  } = usePanelStateAtom();
  const setVerticalsDrillInPageIdAtom = useSetAtom(verticalsDrillInPageIdAtom);
  const navigateToPage = useNavigation();
  const groupData = getGroupData(pageId);
  if (!groupData) {
    throw new Error(`Group data not found for pageId: ${pageId}.`);
  }
  const onGroupToggle = useCallback(toggleType => {
    if (toggleType === ToggleType.Expand) {
      setVerticalsDrillInPageIdAtom(pageId);
      navigateToPage(pageId);
    }
  }, [pageId, navigateToPage, setVerticalsDrillInPageIdAtom]);
  const {
    ruleGroupProps
  } = useBasePageGroup({
    expansionMode: GroupExpansionStyle.button,
    onGroupToggleCallback: onGroupToggle,
    pageId,
    ruleResults: []
  });
  return {
    verticalPageGroupProps: ruleGroupProps
  };
};
//# sourceMappingURL=use-vertical-page-group.js.map